<div style="max-width: 700px; margin-left: auto; margin-right: auto" class="m-portlet mf-portlet-gray__gray-background">
    <div class="m-portlet__body mt-5 pt-2">
        <div class="d-flex justify-content-end">
            <span>
                <a (click)="activeModal.close()" class="m-portlet__nav-link btn m-btn m-btn--hover-info m-btn--icon m-btn--icon-only m-btn--pill">
                    <i class="la la-times"></i>
                </a>
            </span>
        </div>
        <div class="d-flex justify-content-center">
            <!-- LOGO -->
            <img width="200px;" src="../../../../assets/app/media/img/medical/medifit_medical-01.svg" />
        </div>
        <div class="d-flex justify-content-center m-3 mb-4">
            <!-- podnaslov -->
            <span>Izberite kako boste zaključili obravnavo.</span>
        </div>

        <div class="d-flex align-items-center mf-portfolio flex-column flex-md-row">
            <!-- 4 IZHODI -->
            <div class="text-center w-100 mb-auto py-2 py-md-0" [ngClass]="{ 'mf-selected-exit': selectedExit == visitExitType.HD_REFERRAL }">
                <div
                    (click)="surveyRestriction ? '' : (selectedExit = visitExitType.HD_REFERRAL); warningNotify(visitExitType.HD_REFERRAL)"
                    class="mf-portfolio__item text-center mx-auto"
                    [ngClass]="{ disabled: surveyRestriction }"
                >
                    <i class="la mf-i-hd-referral la-5x"></i>
                </div>
                <div class="text-uppercase">Sekundarij</div>
            </div>
            <div
                *ngIf="this.term?.reservationType !== 'WIDGET_VOUCHER'"
                class="text-center w-100 mb-auto py-2 py-md-0"
                [ngClass]="{ 'mf-selected-exit': selectedExit == visitExitType.PHYSICAL_EXAM }"
            >
                <div
                    (click)="physicalExamRestriction ? '' : (selectedExit = visitExitType.PHYSICAL_EXAM); warningNotify(visitExitType.PHYSICAL_EXAM)"
                    class="mf-portfolio__item text-center mx-auto"
                    [ngClass]="{ disabled: physicalExamRestriction }"
                >
                    <i class="la mf-i-stethoscope la-5x"></i>
                </div>
                <div class="text-uppercase">Fizični pregled</div>
            </div>

            <div class="text-center w-100 mb-auto py-2 py-md-0" [ngClass]="{ 'mf-selected-exit': selectedExit == visitExitType.PUBLIC_HEALTH }">
                <div (click)="selectedExit = visitExitType.PUBLIC_HEALTH" class="mf-portfolio__item text-center mx-auto">
                    <i class="la mf-i-network la-5x"></i>
                </div>
                <div class="text-uppercase">Javna zdravstvena mreža</div>
            </div>
            <div class="text-center w-100 mb-auto py-2 py-md-0" [ngClass]="{ 'mf-selected-exit': selectedExit == visitExitType.SELF_HELP }">
                <div (click)="selectedExit = visitExitType.SELF_HELP" class="mf-portfolio__item text-center mx-auto">
                    <i class="la mf-i-selfhelp la-5x"></i>
                </div>
                <div class="text-uppercase">Samopomoč</div>
            </div>
            <div
                *ngIf="this.term?.reservationType === 'LAIFP' || this.term?.reservationType === 'LAIFD' || this.term?.originUrl === 'LAIF'"
                class="text-center w-100 mb-auto py-2 py-md-0"
                [ngClass]="{ 'mf-selected-exit': selectedExit == visitExitType.LIFE_STYLE }"
            >
                <div (click)="selectedExit = visitExitType.LIFE_STYLE" class="mf-portfolio__item text-center mx-auto">
                    <i class="la mf-i-cross la-5x"></i>
                </div>
                <div class="text-uppercase">Življenjski slog</div>
            </div>
            <div class="text-center w-100 mb-auto py-2 py-md-0" [ngClass]="{ 'mf-selected-exit': selectedExit == visitExitType.TECHNICAL_ISSUE }">
                <div (click)="selectedExit = visitExitType.TECHNICAL_ISSUE" class="mf-portfolio__item text-center mx-auto">
                    <i style="margin-right: 20px" class="la mf-i-failed-bubble la-5x"></i>
                </div>
                <div class="text-uppercase">Neuspeli klic/Drugo</div>
            </div>
        </div>
        <div *ngIf="selectedExit == visitExitType.TECHNICAL_ISSUE">
            <div class="form-group m-form__group row my-4 mx-1">
                <div class="col-12">
                    <form [formGroup]="technicalIssuesCommentForm" novalidate>
                        <ng-select
                            [items]="this.technicalIssuesComments"
                            [addTag]="true"
                            [clearable]="true"
                            bindLabel="comment"
                            bindValue="comment"
                            addTagText="Dodaj lasten komentar"
                            placeholder="Komentar"
                            formControlName="concludeComment"
                        >
                            <ng-template style="overflow-y: scroll" ng-option-tmp let-item="item">
                                <div>
                                    {{ item.comment }}
                                </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="(technicalIssuesCommentForm?.controls)['concludeComment'].errors && formSubmited" class="m--font-danger">
                            <small [hidden]="!(technicalIssuesCommentForm?.controls)['concludeComment'].errors.required" i18n="@@2767054721515520309">
                                Izbira oziroma vnos komentarja je obvezno.
                            </small>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div *ngIf="selectedExit == visitExitType.LIFE_STYLE">
            <div class="form-group m-form__group row my-4 mx-1">
                <div class="col-12">
                    <form [formGroup]="lifeStyleCommentForm" novalidate>
                        <ng-select
                            [items]="this.lifeStyleComments"
                            [addTag]="true"
                            [clearable]="true"
                            bindLabel="comment"
                            bindValue="comment"
                            addTagText="Dodaj lasten komentar"
                            placeholder="Komentar"
                            formControlName="concludeComment"
                        >
                            <ng-template style="overflow-y: scroll" ng-option-tmp let-item="item">
                                <div>
                                    {{ item.comment }}
                                </div>
                            </ng-template>
                        </ng-select>
                    </form>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center mt-4">
            <!-- ZAKLJUČI OBRAVNAVO -->
            <button [disabled]="!selectedExit" (click)="concludeVisit()" class="btn m-btn m-btn--pill btn-accent m-btn--icon">
                Zaključi obravnavo
            </button>
        </div>
    </div>
</div>
